import { ListingModalOptionWrapper } from "./ListingModalOptionWrapper";
import { ListingModalOptionHeader } from "./ListingModalOptionHeader";
import { ListingModalOptionTitle } from "./ListingModalOptionTitle";
import { AppPrimaryButton } from "../../../../global/ui/buttons";
import { formatPriceFromStripe } from "../../../../../lib/listings";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useListingModalPlanOptionsContext } from "./ListingModalPlanOptionsProvider";
import { useSnackbarContext } from "../../../../global/snackbar/SnackbarProvider";
import { ErrorSnackbar } from "../../../../global/snackbar";
import { useListingModalOptionContext } from "./ListingModalOptionProvider";

export const ListingModalBronzeOption = () => {
  const prices = useSelector((state: RootState) => state.stripePrices?.value);
  const { handleNormalSubscription } = useListingModalPlanOptionsContext();
  const { setSnackbar } = useSnackbarContext();
  const { state, dispatch } = useListingModalOptionContext();

  const joinBronzeHandler = async () => {
    try {
      dispatch({ isLoading: true });
      await handleNormalSubscription(prices.bronze.id);
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);
    } finally {
      dispatch({ isLoading: false });
    }
  };

  return (
    <ListingModalOptionWrapper>
      <ListingModalOptionHeader>
        <ListingModalOptionTitle>
          {prices?.bronze.subscriptionPlanPaymentProviders[0].totalPlans}{" "}
          complete training plans per month.{" "}
          {prices?.bronze.subscriptionPlanPaymentProviders[0].currentPlans}{" "}
          active plan at a time (switch anytime).
        </ListingModalOptionTitle>
      </ListingModalOptionHeader>

      <AppPrimaryButton
        disabled={state.isLoading}
        onClick={() => void joinBronzeHandler()}
        className={"w-full text-[14px] md:text-[12px] xl:text-[14px]"}
      >
        Bronze from €{formatPriceFromStripe(prices.bronze)}/month
      </AppPrimaryButton>
    </ListingModalOptionWrapper>
  );
};
